import React, {Component} from 'react'
import {Link} from 'react-router'
import DenguefeverPhoto from '../../images/Denguefever.jpg'
import Youtube from '../../Component/Youtube'

const Jeyu = {
  DengueFeverBox: {
    background:'#9e3030',
    padding: '183px 10px 140px'

  },
  bannerPhotoBox: {
    width: 200,
    height: 200,
    overflow: 'hidden',
    borderRadius: 150,
    boxShadow: '1px 1px 7px rgba(0,0,0,.2)'
  },
  bannerPhoto: {
    width: 200,
    height: 200,
  },
  center: {
   display: 'block',
   textAlign: 'left'
  },
  h1: {
    fontSize: 30,
    textAlign: 'left',
    fontWeight: 'unset',
    color: '#fff',
    margin: '10px 0 0 0'
  },
  p: {
    fontSize: 20,
    color: '#fff',
    textAlign: 'left',
    margin: 0,
    fontWeight: 100
  },
  pinfo: {
    fontSize: 18,
    textAlign: 'left',
    margin: '20px 0',
    fontWeight: 100
  },
  h2: {
    fontSize: 23,
    fontWeight: 300
  },
  tag: {
    background: 'rgb(21, 222, 203)',
    color: 'rgb(1, 72, 82)',
    padding: '2px 15px',
    borderRadius: 7,
    fontSize: 16,
    marginRight: 10,
    fontWeight: 500
  },
  time: {
    marginLeft: 10
  },
  haspt: {
    paddingTop: 17
  },
  Section: {
    padding: '0 0 20px 0'
  },
  Article: {
    padding: 15
  }
}

export default class DengueFever extends Component {
  componentDidMount () {
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    window.scrollTo(0, 0)
  }
  render() {
    return(
      <div className="container-fluid">
       <div className="row">
        <div style={Jeyu.DengueFeverBox} className="DengueFeverBox">
         <div className="container">
          <div className="row">
           <div className="xs-12 sm-6 md-8 lg-8">
            <div style={Jeyu.haspt}>
             <p style={Jeyu.p}><Link to="/" style={Jeyu.tag}>登革熱</Link> Jeyutex <time datetime="2017-04-12 15:35" style={Jeyu.time}>Apr 12, 2017</time></p>
             <h1 style={Jeyu.h1}>可怕的急性傳染病:登革熱!</h1>
             <p style={Jeyu.p}>經由蚊子傳播給人類。並且依據不同的血清型病毒，分為Ⅰ、Ⅱ、Ⅲ、Ⅳ四種型別，而每一型都具有能感染致病的能力。</p>
             <p style={Jeyu.p}>認識登革熱的相關知識,才能有效的制止登革熱生長</p>
            </div>
           </div>
           <div className="xs-12 sm-6 md-4 lg-4">
            <div style={Jeyu.bannerPhotoBox} className="bannerPhotoBox">
             <img src={DenguefeverPhoto} alt="Dust Mite" style={Jeyu.bannerPhoto} className="bannerPhoto"/>
            </div>
           </div>
          </div>
         </div>
        </div>

        <div className="container">
         <div className="row">
          <section style={Jeyu.Section}>
           <article style={Jeyu.Article}>
           <sub>參考文獻: wiki百科</sub>
            <h2 style={Jeyu.h2}>登革熱(dengue fever)</h2>
            <p style={Jeyu.pinfo}>
             又稱為骨痛熱症、斷骨熱、天狗熱，是由登革熱病毒引起的由蚊子傳播的熱帶病
            </p>
            <p style={Jeyu.pinfo}>
             臨床上重複感染不同型登革病毒，可引起宿主不同程度的反應，從輕微或不明顯的症狀，到發燒、出疹的典型登革熱，或出現嗜睡、躁動不安、肝臟腫大等警示徵象，甚至可能導致嚴重出血或嚴重器官損傷的登革熱重症。
            </p>
           </article>
           <article style={Jeyu.Article}>
            <h2 style={Jeyu.h2}>症狀</h2>
            <p style={Jeyu.pinfo}>
             一般來說，登革病毒感染者80％都無症狀，或者只有輕度症狀如簡單的發燒。
            </p>
            <p style={Jeyu.pinfo}>
             其它感染者中5％有嚴重臨床症狀，其中一小部分患者生命會受到威脅。
            </p>
            <p style={Jeyu.pinfo}>
             登革熱的特徵性臨床表現是突發高熱，頭痛（一般位於眼後），肌肉及關節痛和皮疹。因為它可以導致肌肉和關節痛，所以又稱為「斷骨熱」。感染過程分為三個時期：急性發熱期，極期和恢復期
            </p>
            <p style={Jeyu.pinfo}>
             急性發熱期患者高熱，體溫可達40 °C（104 °F），伴有全身疼痛和頭痛，通常會持續2－7天。也可有噁心、嘔吐。<br />
             50－80%患者中，出現症狀的第一或第二天會出現皮疹，皮膚發紅，或者在病程靠後（4–7天）出現麻疹樣皮疹。<br />
             也有觀察到中央發白周圍發紅的皮疹。此時，一些瘀點（小的紅斑，壓之不褪色，由毛細血管破裂所致）會出現，伴隨口腔和鼻腔黏膜的少量出血。<br />
             發燒為典型的雙峰或馬鞍熱，發熱1－2天後體溫降至正常。
            </p>
           </article>
           <article style={Jeyu.Article}>
            <h2 style={Jeyu.h2}>如何預防</h2>
            <p style={Jeyu.pinfo}>
             目前登革熱病毒沒有獲得批准的疫苗。因此預防依賴於避免被傳播病毒的蚊子叮咬。
            </p>
            <p style={Jeyu.pinfo}>
             控制斑蚊的主要方法是消滅其滋生地，具體措施是清除開放水源，如果不行，就噴灑滅蚊劑或生物控制劑。<br />
             一般噴灑的是有機磷酸酯或擬除蟲菊酯類殺蟲劑，雖然其效益備受質疑（台灣常有噴藥造成嚴重困擾但沒幾天蚊子就回復原數量的抱怨）。<br />
             考慮到殺蟲劑對健康的負面影響、容易殺死寵物、流浪動物甚至破壞生態（毒性較低的除蟲菊精類對貓及水生生物仍是劇毒，在法規允許破門噴藥的台灣已造成多起悲劇）<br />
             、抗藥性問題及生物控制劑使用上更大的物流困難，通過改善環境減少積水是首選控制措施。<br />
             人們可以通過穿完全遮蓋皮膚的衣服，休息時使用蚊帳，或使用驅蟲劑（最有效的是DEET）來防止被蚊子叮咬。<br />
             然而，這些方法看上去還不夠有效，因為一些地區登革熱爆發的頻率似乎還在上升，可能因為城鎮化與氣候變化增加了埃及斑蚊的棲息地。導致區域範圍持續況大中。
            </p>
           </article>
          </section>
         </div>
        </div>
        <Youtube />
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/View/Blog/DengueFever.js